module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/transfer/transfer-sanction/transfer-sanction-grid/transfer-sanction-grid.component.css
// module id = ./src/app/hrms/transfer/transfer-sanction/transfer-sanction-grid/transfer-sanction-grid.component.css
// module chunks = main